import { render, staticRenderFns } from "./IsOldLogBar.vue?vue&type=template&id=4308e10e"
import script from "./IsOldLogBar.vue?vue&type=script&lang=js"
export * from "./IsOldLogBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports